import { inject } from '@angular/core';
import { CanMatchFn, UrlSegment, Route } from '@angular/router';
import { FeatureAccessService } from '../services/feature-access.service';

export function featureAccessMatchGuard(featureChecker: (featureAccessService: FeatureAccessService) => boolean): CanMatchFn { 
  return (route: Route, segments: UrlSegment[]) => {
    const featureAccessService = inject(FeatureAccessService);
    return featureChecker(featureAccessService);
  };
}
